// @flow
import { handleResponseOld, handleResponseUseItemApiError, handleResponseWithNon200Errors, makePost } from './helpers';

type PostChangePasswordParams = {
    authToken: string,
    deployment: string,
    newPassword: string,
    oldPassword: string,
};

export const postChangePassword = ({ authToken, deployment, newPassword, oldPassword }: PostChangePasswordParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'updatepassword', authToken, deployment, path: '<USER-API>' });
        request.send({ newPassword, oldPassword });
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });

type PostConfirmPasswordParams = {
    deployment: string,
    password: string,
    username: string,
};

export const postConfirmPassword = ({ deployment, password, username }: PostConfirmPasswordParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>auth/spalogin' });
        request.send({ password, username });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostForgotPasswordParams = {
    authToken: string,
    deployment: string,
    emailAddress: string,
};

export const postForgotPassword = ({ authToken, deployment, emailAddress }: PostForgotPasswordParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: '<MAINHOST-API>api/pw_reset',
            queryParams: { client_version: '4.3' },
        });
        const [username, domain] = emailAddress.split('@');
        request.type('form');
        request.send({ email: `${username.replace('+', '%2B')}@${domain}` }); // To allow emails with pluses
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostResetPasswordParams = {
    bidderId: number,
    deployment: string,
    hash: string,
    newPassword: string,
};

export const postResetPassword = ({ bidderId, deployment, hash, newPassword }: PostResetPasswordParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>auth/spa/reset-password' });
        request.send({ bidderId, hash, newPassword });
        request.end((err, response) => handleResponseUseItemApiError({ err, reject, resolve, response }));
    });
